import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-a7c2723c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "text-base curriculum-popup-container" }
const _hoisted_2 = { class: "flex" }
const _hoisted_3 = ["disabled"]
const _hoisted_4 = ["disabled"]


export default /*#__PURE__*/_defineComponent({
  __name: 'CoachMessagePopup',
  props: {
  coachMessage: {
    type: String,
    default: undefined,
  },
  isLoading: {
    type: Boolean,
    default: false,
  },
},
  emits: ['on-close', 'confirm-solution'],
  setup(__props, { emit: __emit }) {

const emit = __emit


const close = () => {
  emit('on-close', false)
}
const coachConfirmSolved = () => {
  emit('confirm-solution')
}

return (_ctx: any,_cache: any) => {
  const _component_Loading = _resolveComponent("Loading")!
  const _component_Popup = _resolveComponent("Popup")!

  return (_openBlock(), _createBlock(_component_Popup, {
    title: "Notify",
    open: !!__props.coachMessage,
    onClose: close
  }, {
    footer: _withCtx(() => [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("button", {
          type: "button",
          class: "btn btn-tertiary text-white text-base w-full",
          disabled: __props.isLoading,
          onClick: close
        }, _toDisplayString(_ctx.$t('help-popup.cancel-btn')), 9, _hoisted_3),
        _createElementVNode("button", {
          type: "button",
          class: "btn btn-primary text-white text-base w-full ml-2",
          disabled: __props.isLoading,
          onClick: coachConfirmSolved
        }, _toDisplayString(_ctx.$t('help-popup.confirm-btn')), 9, _hoisted_4)
      ])
    ]),
    default: _withCtx(() => [
      _createVNode(_component_Loading, {
        class: "curriculum-popup-container",
        "background-color": "#ffffffac",
        "is-fullscreen": "",
        "is-loading": __props.isLoading,
        size: "36"
      }, null, 8, ["is-loading"]),
      _createElementVNode("span", _hoisted_1, _toDisplayString(__props.coachMessage), 1)
    ]),
    _: 1
  }, 8, ["open"]))
}
}

})